






import Vue from 'vue'
export default Vue.extend({
  name: 'Button',
  props: {
    label: String,
    type: String,
    key: String,
    handleClick: Function
  }
})
